(function(){
  function initMobileMenu(){
    document.querySelectorAll('[data-site-header]').forEach(function(header){
      if(header.dataset.mobileMenuReady === 'true') return;
      header.dataset.mobileMenuReady = 'true';

      var toggle=header.querySelector('[data-mobile-toggle]');
      var menu=header.querySelector('[data-mobile-menu]');
      if(!toggle || !menu) return;

      function setOpen(open){
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        menu.hidden=!open;
        menu.classList.toggle('is-open',open);
      }

      toggle.addEventListener('click',function(){
        setOpen(toggle.getAttribute('aria-expanded')!=='true');
      });

      menu.addEventListener('click',function(e){
        if(e.target.closest('a')) setOpen(false);
      });

      window.addEventListener('resize',function(){
        if(window.innerWidth>760) setOpen(false);
      });
    });
  }

  function initStickyHeaders(){
    document.querySelectorAll('[data-site-header]').forEach(function(header){
      if(header.dataset.stickyReady === 'true') return;
      header.dataset.stickyReady = 'true';

      var wrapper=header.closest('.shopify-section');
      var sticky=header.classList.contains('ns-header--sticky');
      if(!wrapper || !sticky) return;

      var triggerTop=0;
      var normalHeight=0;
      var ticking=false;

      function measure(){
        header.classList.remove('is-fixed','is-scrolled');
        wrapper.style.height='';
        var rect=wrapper.getBoundingClientRect();
        triggerTop=window.scrollY + rect.top;
        normalHeight=Math.ceil(header.getBoundingClientRect().height);
        update();
      }

      function update(){
        var shouldFix=window.scrollY >= triggerTop;

        if(shouldFix){
          /* Preserve the header's original space in the document. Do not keep
             recalculating this from the compact fixed header, otherwise the
             page itself moves upward while the logo is transitioning. */
          wrapper.style.height=normalHeight + 'px';
          if(!header.classList.contains('is-fixed')){
            header.classList.add('is-fixed');
          }
        } else {
          header.classList.remove('is-fixed');
          wrapper.style.height='';
        }

        /* Start the logo transition on the exact same frame that the header becomes fixed.
           This prevents the fixed header from briefly showing the overlapping crest
           and then shifting again a few pixels later on mobile. */
        header.classList.toggle('is-scrolled', shouldFix);
        ticking=false;
      }

      measure();

      window.addEventListener('scroll',function(){
        if(!ticking){
          window.requestAnimationFrame(update);
          ticking=true;
        }
      },{passive:true});

      window.addEventListener('resize',function(){
        window.clearTimeout(header._nsmResizeTimer);
        header._nsmResizeTimer=window.setTimeout(measure,100);
      });
    });
  }

  function initAll(){
    initMobileMenu();
    initStickyHeaders();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load',initAll);
})();
